<template>
     <div class="container" v-title="'组织架构'">
         <Navigation-bar title="组织架构" v-scrollShadow="roll"></Navigation-bar>
        <div class="container_content">
            <div id="OrganizationalStructure" v-scroll="roll">
                <div class="OrganizationalStructure_content">
                    <h3>办事机构：</h3>
                    <p>
                        秘书处<br>
                        会员管理处
                    </p>
                    <h3 style="margin-top:0.32rem">专业委员会：</h3>
                    <p>
                        足球专业委员会<br>
                        篮球专业委员会<br>
                        排球专业委员会<br>
                        乒羽专业委员会<br>
                        网球专业委员会<br>
                        棋牌专业委员会<br>
                        健身专业委员会<br>
                        汽车摩托车运动专业委员会<br>
                        门球专业委员会<br>
                        综合搏击专委会<br>
                        青少年体育发展专业委员会
                    </p>
                </div>
            </div>
        </div>
     </div>
</template>
<script>
export default {
    name:"OrganizationalStructure",
    data(){
        return{
            roll:0,
        }
    }
}
</script>
<style lang="scss" scoped>
#OrganizationalStructure{
    padding: 24px 40px 110px;
    box-sizing: border-box;
    .OrganizationalStructure_content{
        width: 100%;
        padding: 40px;
        box-sizing: border-box;
        font-size: 28px;
        color: #50506A;
        line-height: 56px;
        font-weight: 400;
        background: #FAFAFC;
        border-radius: 12px;
        h3{
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            line-height: 44px;
            margin-bottom: 16px;
        }
    }
}
</style>